// jshint ignore: start
exports.inject = function(module) {
  module.factory('LoginFlowAnimation', exports.factoryFlowAnims);
  module.directive('loginFlowAnimation', exports.directiveFlowAnims);
};

exports.factoryFlowAnims = function() {
  return {
    percentage: null,
    afterMessage: {
      loginError: false,
      forgotPasswordSuccess: false,
      changePasswordFail: false
    },
    setPercentage: function(pct) {
      this.percentage = parseInt(pct / 100 * 100, 10);
      this.resetAfterMessages();
    },
    clearPercentage: function() {
      this.percentage = null;
    },
    getAfterMessages: function() {
      return this.afterMessage;
    },
    showAfterMessages: function(name) {
      this.resetAfterMessages();
      if(this.afterMessage[name] !== undefined) {
        this.afterMessage[name] = true;  
      }
    },
    resetAfterMessages: function() {
      this.afterMessage.loginError = false;
      this.afterMessage.forgotPasswordSuccess = false;
      this.afterMessage.changePasswordFail = false;
    }
  }  
};

exports.directiveFlowAnims = ['$timeout', function ($timeout) {
  return {
    scope: {},
    restrict: 'A',
    controller: ['$scope', 'LoginFlowAnimation', function($scope, LoginFlowAnimation) {
      $scope.api = LoginFlowAnimation;
    }],
    link: function(scope, element, attrs) {
      scope.login_progressbar = element.find('.login-progressbar div');
      scope.login_progressbar_indicator = element.find('.login-progressbar-indicator h3');
      scope.login_progressbar_indicator.html('0%');
      scope.login_form = element.find('#form_for_user');
      scope.login_error = element.find('.form-login-error');
      scope.forgot_password_success = element.find('.form-forgotpassword-success');
      scope.change_password_fail = element.find('.form-changepass-fail');

      scope.$watch('api.percentage', function(newValue, oldValue) {
        if(newValue == oldValue) {
          return;
        }
        if(newValue == null) {
          scope.resetPercentage(scope.api.getAfterMessages());
        } else {
          var pct = newValue + '%';
          scope.animatePercentage(pct);
        }
      });
      
      scope.animatePercentage = function(pct) {
        scope.hideAllMessages();
        scope.login_progressbar_indicator.html(pct);
        scope.login_progressbar.width(pct);       
        var o = {
				  pct: parseInt(scope.login_progressbar.width() / scope.login_progressbar.parent().width() * 100, 10)
			  };
				TweenMax.to(o, .7, {
					pct: parseInt(pct, 10),
					roundProps: ["pct"],
					ease: Sine.easeOut,
					onUpdate: function() {
						scope.login_progressbar_indicator.html(o.pct + '%');
					}
				});
      };
      
      scope.resetPercentage = function(afterMessage) {
        TweenMax.set(scope.login_form, {css: {opacity: 0}});  
        $timeout(function() {
          TweenMax.to(scope.login_form, .6, {
            css: {opacity: 1}, 
            onComplete: function() {
					    scope.login_form.attr('style', '');
				    }
          });
				
				  scope.login_progressbar_indicator.html('0%');
				  scope.login_progressbar.width(0);
				  
				  afterMessage.loginError && scope.showLoginError();
				  afterMessage.forgotPasswordSuccess && scope.showForgotPasswordSuccess();
        }, 500);
      };
      
      scope.showLoginError = function() {
        scope.login_error.length > 0 && scope.login_error.show();
      };
      
      scope.showForgotPasswordSuccess = function() {
        scope.forgot_password_success.length > 0 && scope.forgot_password_success.show();
      };

      scope.showChangePasswordFail = function() {
        scope.change_password_fail.length > 0 && scope.change_password_fail.show();
      };
      scope.hideAllMessages = function() {
        scope.login_error.length > 0 && scope.login_error.hide();
        scope.forgot_password_success.length > 0 && scope.forgot_password_success.hide();
        scope.change_password_fail.length > 0 && scope.change_password_fail.hide();
      };
    }
  };
}];


/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/authorization-directives.js
 ** module id = 295
 ** module chunks = 0
 **/